import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'
import SentryRRWeb from '@sentry/rrweb'
import app from './lib/pico-init'
import $ from './lib/quantdom'
import logBeyondBrand from '@thebeyondgroup/brand'

logBeyondBrand()

Sentry.init({
  dsn: 'https://f1caec4d9bc948c4b3768365b032ec93@o4504237782859776.ingest.sentry.io/4504237799964672',
  integrations: [
    new BrowserTracing(),
    new SentryRRWeb({
      errorsOnly: true,
    }),
  ],
  // We recommend adjusting this value in production, or using tracesSampler  for finer control
  tracesSampleRate: 0.33,
  allowUrls: [/https:\/\/cdn.shopify.com\/s\/files\/1\/1269\/8457\/t\/267\/assets\/*/, /https:\/\/hukitchen.com\/*/],
  denyUrls: [/cdn.shopify.com\/shopifycloud/],
})

app.mount()

//web components
import { AccordionItem } from './components/web-components/accordion-item'
import { AddButton } from './components/web-components/add-button'
import { BodyOverlay } from './components/web-components/body-overlay'
import { CartCount } from './components/web-components/cart-count'
import { CartDrawer } from './components/web-components/cart-drawer'
import { DropdownButton } from './components/web-components/dropdown-button'
import { MegaButton } from './components/web-components/mega-button'
import { MegaMenu } from './components/web-components/mega-menu'
import { SideDrawer } from './components/web-components/side-drawer'
import { SideDrawerBtn } from './components/web-components/side-drawer-btn'
import { SearchSuggest } from './components/web-components/search-suggest'

export {
  AccordionItem,
  AddButton,
  BodyOverlay,
  CartCount,
  CartDrawer,
  DropdownButton,
  MegaButton,
  MegaMenu,
  SideDrawer,
  SideDrawerBtn,
  SearchSuggest,
}

window.addEventListener('keydown', function (e) {
  let keyCode = e.keyCode || e.which
  if (keyCode == 9) {
    document.querySelector('body').classList.add('accessible')
  }
})

window.MicroBus.on('shipscout:response', ({ detail }) => {
  const { thresholdAmount } = detail
  $('.js-main-banner-message').html()
  const banner = $('.js-main-banner-message')
  const oldThreshold = banner.text().match(/\$\d+/)
  const html = banner.html().replace(oldThreshold, thresholdAmount)
  banner.html(html)
  banner.attr('data-hide-text', 'false')
})
